import React from 'react'
import { Box, Typography } from '@mui/material'
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft'
import { ICON_CELL, ICON_INSET, SIDEBAR_TRANSITION, fade, reducedMotion } from './sidebarMotion'

interface SidebarCollapseButtonProps {
  isCollapsed: boolean
  isDarkMode: boolean
  onToggle: () => void
}

const SidebarCollapseButton: React.FC<SidebarCollapseButtonProps> = ({
  isCollapsed,
  isDarkMode,
  onToggle,
}) => (
  <Box
    role="button"
    aria-label={isCollapsed ? 'הרחבת תפריט' : 'כיווץ תפריט'}
    onClick={onToggle}
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      boxSizing: 'border-box',
      width: '100%',
      overflow: 'hidden',
      pr: ICON_INSET,
      pl: 1.5,
      py: 1,
      borderRadius: 1.5,
      cursor: 'pointer',
      color: isDarkMode ? '#FFFFFF' : '#003F61',
      '&:hover': {
        backgroundColor: isDarkMode
          ? 'rgba(148,163,184,0.14)'
          : 'rgba(0, 63, 97, 0.06)',
      },
    }}
  >
    <Typography
      aria-hidden={isCollapsed}
      sx={{
        fontFamily:
          'Rubik, system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif',
        fontSize: 'clamp(13px, 1vw, 16px)',
        whiteSpace: 'nowrap',
        flexShrink: 0,
        color: 'inherit',
        ...fade(!isCollapsed),
      }}
    >
      כיווץ תפריט
    </Typography>
    <Box
      sx={{
        width: ICON_CELL,
        flexShrink: 0,
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <KeyboardDoubleArrowLeftIcon
        data-testid="sidebar-toggle-chevron"
        data-direction={isCollapsed ? 'left' : 'right'}
        sx={{
          fontSize: 22,
          transform: isCollapsed ? 'rotate(0deg)' : 'rotate(180deg)',
          transition: `transform ${SIDEBAR_TRANSITION}`,
          ...reducedMotion,
        }}
      />
    </Box>
  </Box>
)

export default SidebarCollapseButton
